




    import {Vue, Component, Prop, Emit, Watch} from 'vue-property-decorator'
    import dataProxy from "@/services/data-proxy.service"
    import {PodgrupaVozila} from "@/services/BackendProxies";

@Component({})
export default class PodgrupaVozilaEditor extends Vue {
    podgrupeVozila = [];
    @Prop() value !: string;
    @Prop() grupaVozilaId!: string;

    model = '';



    @Watch("value") onValueChange(value) {
        if (value || value === null) {
            this.model = value;
        }
    }

    @Watch("model") onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value) {
    }

    @Watch("grupaVozilaId")
    async ucitaj(grupaVozilaId) {
        const value = this.value;
        if (grupaVozilaId) {
            const grupeVozila = await dataProxy.vratiGrupeVozila();
            const grupaVozila = grupeVozila.find(x => x.id == grupaVozilaId);
            if (grupaVozila) {
                this.podgrupeVozila = grupaVozila.podgrupeVozila.map(p => ({id: p.id, text: p.naziv}));
                this.podgrupeVozila.unshift({id: '', text: '...'});
            }
        }
        this.model = value;
    }
}
